module.exports = __webpack_public_path__ + "img/wales-logo-icon.19dfbbfc.png";